import { render, staticRenderFns } from "./AttentionLegend.vue?vue&type=template&id=5a069176&scoped=true&"
import script from "./AttentionLegend.vue?vue&type=script&lang=js&"
export * from "./AttentionLegend.vue?vue&type=script&lang=js&"
import style0 from "./AttentionLegend.vue?vue&type=style&index=0&id=5a069176&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a069176",
  null
  
)

export default component.exports